/* eslint-disable max-len */
import '../scss/main.scss';

// API endpoint configuration
// const API_ENDPOINT = 'http://localhost:3001/api/contact';
const API_ENDPOINT = 'https://www.api.blandford-oakwoodtaxis.co.uk/api/contact';
const API_KEY = '2b55be1faaed6330d50647cffb3f48f689862428afa26899d3422b9bc63346e5';

// eslint-disable-next-line func-names
document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line func-names, no-inner-declarations
  function clearFieldErrors() {
    // Remove error highlighting from all fields
    ['inputName', 'inputEmail', 'inputPhone', 'inputQuery'].forEach((fieldId) => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.classList.remove('is-invalid');
      }
    });
  }

  // eslint-disable-next-line func-names, no-inner-declarations
  function highlightFieldErrors(details) {
    clearFieldErrors();

    // Map field names to input IDs
    const fieldMap = {
      name: 'inputName',
      email: 'inputEmail',
      phone: 'inputPhone',
      query: 'inputQuery',
    };

    // Highlight fields with errors
    details.forEach((detail) => {
      const inputId = fieldMap[detail.field];
      if (inputId) {
        const field = document.getElementById(inputId);
        if (field) {
          field.classList.add('is-invalid');
        }
      }
    });
  }

  // eslint-disable-next-line func-names, no-inner-declarations
  async function submitForm() {
    console.log('Submit form called');
    // Clear any previous field errors
    clearFieldErrors();

    // Disable button to prevent double submissions
    const submitButton = document.getElementById('form-btn');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerText = 'Sending...';
    }

    const name = document.getElementById('inputName').value;
    const email = document.getElementById('inputEmail').value;
    const phone = document.getElementById('inputPhone').value;
    const query = document.getElementById('inputQuery').value;

    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': API_KEY,
        },
        body: JSON.stringify({
          name,
          email,
          phone,
          query,
        }),
      });

      const data = await response.json();

      // Re-enable button
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerText = 'Submit';
      }

      if (response.ok) {
        document.getElementById('form-message').innerText = 'Thank you, your query was successfully received. We will get back to you soon.';
        document.getElementById('form-message-error').innerText = '';

        // Clear form fields and any error highlighting
        clearFieldErrors();
        document.getElementById('inputName').value = '';
        document.getElementById('inputEmail').value = '';
        document.getElementById('inputPhone').value = '';
        document.getElementById('inputQuery').value = '';
      } else {
        // Handle different error responses
        let errorMessage = 'Sorry, there has been a problem sending the message. Please phone or email us directly.';

        if (response.status === 400 && data.details && data.details.length > 0) {
          // Validation errors - list each message and highlight fields
          errorMessage = data.details.map((detail) => detail.message).join('\n');
          highlightFieldErrors(data.details);
        } else if (response.status === 429) {
          errorMessage = 'Too many requests. Please wait a few minutes and try again, or call us directly.';
        } else if (response.status === 503) {
          errorMessage = 'Service temporarily unavailable. Please try again later or call us directly.';
        } else if (response.status === 401 || response.status === 403) {
          errorMessage = 'Authentication error. Please try again later or contact us directly.';
        } else if (data.error) {
          errorMessage = data.error;
        }

        console.error('API error:', response.status, data);
        document.getElementById('form-message-error').innerText = errorMessage;
        document.getElementById('form-message').innerText = '';
      }
    } catch (error) {
      console.error('Exception in submitForm:', error);
      document.getElementById('form-message-error').innerText = 'Sorry, there has been a problem sending the query. Please phone or email us directly.';
      document.getElementById('form-message').innerText = '';
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerText = 'Submit';
      }
    }
  }

  // Add event listener to the submit button
  const submitBtn = document.getElementById('form-btn');
  if (submitBtn) {
    // Flag to prevent double submission
    let isSubmitting = false;
    const handleSubmit = (e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log('Button event triggered'); // Debug log

      if (!isSubmitting) {
        isSubmitting = true;
        submitForm();
        // Reset flag after a delay
        setTimeout(() => {
          isSubmitting = false;
        }, 2000);
      }
    };
    submitBtn.addEventListener('click', handleSubmit);
  } else {
    console.error('Submit button not found!');
  }
});
